module.exports = __webpack_public_path__ + "images/emoji/ice_cream.e0efac1faf462b688ba8.png";